import { RemoteParamKeys, useExperiment } from '@/lib/firebase/hooks'

/**
 * This hook is being used to determine if the user is in one of the test groups for SRP_ADS_REINVENTION_TEST.
 * There are 2 different variations being tested. AdsenseSrpContainer with the id "AFSTop" will be hidden on both.
 * 1 variation will have category tree + vertical adsense container on the left, and one will hide the category tree
 * and have a vertical adsense container on the right.
 *
 * For more info please refer to: https://jira.ets.mpi-internal.com/browse/KJCA-6267
 */
export const useAdsReinventionExperiment = (isMobile?: boolean) => {
  const adsReinventionExperiment = useExperiment(RemoteParamKeys.SRP_ADS_REINVENTION_TEST)
  const { enabled, group } = adsReinventionExperiment ?? {}
  const isAdsReinventionExperimentEnabled =
    enabled === true && (group === 1 || group === 2) && !isMobile
  return { isAdsReinventionExperimentEnabled, adsReinventionExperimentGroup: group }
}
